import currencyService from "@/services/currency";
export const currency = {
    namespaced: true,
    state: {
        list: []
    },
    getters: {
        currencies: state => state.list.map(currency => ({ value: currency.id, label: `${currency.shortName}:${currency.name}` }))
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        }
    },
    actions: {
        async populate({ commit, state }) {
            if (!state.list.length) {
                const list = await currencyService.getAll();
                commit("SET_LIST", list);
                return list;
            }
        },
        clear({ commit }) {
            commit("SET_LIST", []);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/currency/index.js